import type { SubscriptionResponse } from '@cvo/domain/';
import type { PlanBenefit } from '@cvo/ui/components/molecules/PlanBenefits/PlanBenefits.model';
import type { Status } from '@cvo/ui/types/designSystem';

export type SubscriptionDetailsData = SubscriptionResponse;

export interface SubscriptionCardProps {
  subscription: SubscriptionDetailsData;
  /** Resolved plan characteristics, supplied by the parent (the plan-characteristics domain lives in the app layer). */
  characteristics: PlanBenefit[];
  showPriceTooltip?: boolean;
}

export interface StatusNotification {
  status: Status;
  text: string;
}

export const notificationMap: Partial<Record<SubscriptionDetailsData['displayStatus'], StatusNotification>> = {
  'OVERDUE': {
    status: 'warning',
    text: 'ui.subscription.details.notifications.overdue',
  },
  'SUSPENDED': {
    status: 'danger',
    text: 'ui.subscription.details.notifications.suspended',
  },
};
